"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@material-ui/core/styles");
const color = require("color");
const styles = (theme) => (0, styles_1.createStyles)({
    codeBlock: {
        marginTop: theme.spacing(2)
    },
    columnHeader: {
        color: theme.palette.text.primary.getMediumEmphasis(),
        textAlign: 'center'
    },
    codeContainer: {
        padding: theme.spacing(2),
        backgroundColor: color(theme.palette.common.black).alpha(0.6).rgb().string(),
        borderRadius: 5
    },
    code: {
        color: theme.palette.primary.contrastText,
        wordBreak: 'break-word'
    },
    copyText: {
        color: theme.palette.primary.main
    },
    instruction: {
        textAlign: 'center',
        marginTop: theme.spacing(),
        marginBottom: theme.spacing(3)
    },
    secondaryColor: {
        color: '#00a8e1'
    }
});
exports.default = styles;
//# sourceMappingURL=CodeBlockStyle.js.map